<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Create Plan</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/plan" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createPlan">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-4">
                                <fg-input type="text"
                                          v-model="plan.name"
                                          label="Name"
                                          placeholder="Enter Name"
                                          v-validate="rules.name"
                                          data-vv-name="name"
                                          cus-name="name"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-md-4" v-if="status.length">
                                <fg-select
                                        v-model="plan.active"
                                        label="Status"
                                        v-validate="rules.active"
                                        data-vv-name="active"
                                        cus-name="active"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="status"
                                        selectedKey="id"
                                        >
                                </fg-select>
                            </div>
                            <div class="col-md-4">
                                <fg-input type="text"
                                          v-model="plan.amount"
                                          label="Amount"
                                          placeholder="Enter Amount"
                                          v-validate="rules.amount"
                                          data-vv-name="amount"
                                          cus-name="amount"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="plan.type"
                                          label="Type"
                                          placeholder="Enter Type"
                                          v-validate="rules.type"
                                          data-vv-name="type"
                                          cus-name="type"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <label>Start Date</label>
                                <datetime v-model="startDate"
                                          input-class="form-control"
                                          placeholder="Choose a Date"
                                          type="datetime"
                                          :min-datetime="startDate"
                                          input-format="DD-MM-YYYY HH:mm"
                                          auto-continue>

                                </datetime>
                            </div>
                            <div class="col-4">
                                <label>End Date</label>
                                <datetime v-model="endDate"
                                          input-class="form-control"
                                          placeholder="Choose a Date"
                                          type="datetime"
                                          input-format="DD-MM-YYYY HH:mm"
                                          auto-continue>

                                </datetime>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="plan.chargeNow"
                                          label="Charge Now"
                                          placeholder="Enter charge now"
                                          v-validate="rules.chargeNow"
                                          data-vv-name="chargeNow"
                                          cus-name="chargeNow"
                                          :has-errors="errors"
                                          :is-fields="fields"
                                          >
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="plan.couponcode"
                                          label="Coupon Code"
                                          placeholder="Enter coupon code"
                                          v-validate="rules.couponcode"
                                          data-vv-name="couponcode"
                                          cus-name="couponcode"
                                          :has-errors="errors"
                                          :is-fields="fields"
                                          >
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="plan.finalAmount"
                                          label="Final Amount"
                                          placeholder="Enter final amount"
                                          v-validate="rules.finalAmount"
                                          data-vv-name="finalAmount"
                                          cus-name="finalAmount"
                                          :has-errors="errors"
                                          :is-fields="fields"
                                          >
                                </fg-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <fg-text-area
                                        rows="2"
                                        v-model="plan.description"
                                        label="Description"
                                        placeholder="Enter Description"
                                        v-validate="rules.description"
                                        data-vv-name="description"
                                        cus-name="description"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        >
                                </fg-text-area>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Plan
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreatePlan',
    data () {
        let dateTime = new Date();
        return {
            startDate: dateTime.toISOString(),
            endDate: new Date(dateTime.setHours(dateTime.getHours() + 1)).toISOString(),
            plan: {
                name : "",
                active : null,
                amount : 0,
                startDate : "",
                endDate : "",
                chargeNow : "",
                couponId : 0,
                couponcode : null,
                description : "",
                finalAmount : null,
                partnerPlanId : null,
                paypalPlanId : null,
                paypalSubscriptionId : null,
                stripePlanSubscriptionId : null,
                type : "",
                userId : null
            },
            status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
            rules: {
                name : {required: true},
                active : {required: true},
                amount : {required: true, decimal:true},
                type : {required: true},
                chargeNow : {required: true, numeric:true},
                couponcode : {required: true},
                description : {required: true},
                startDate : {required: true},
                endDate : {required: true},
                finalAmount : {required: true, decimal:true}
            },
        }
    },
    methods: {
        createPlan () {
            let startDate = new Date(this.startDate).getTime();
            let endDate = new Date(this.endDate).getTime();
            console.log("moment(startDate).format('MM/DD/YYYY h:mm:ss') : ", moment(startDate).format('MM/DD/YYYY H:mm:ss'));
            console.log("moment(endDate).format('MM/DD/YYYY h:mm:ss') : ", moment(endDate).format('MM/DD/YYYY H:mm:ss'));
            if(endDate < startDate){
                this.showPopup('Error!', 'Plan End Date must be greater then start Date.', 'error')
            }
            /*else if(!this.event.img_url){
             this.showPopup('Error!', 'Event Image is not selected', 'error')
             }*/
            else{
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.plan.startDate =  moment(startDate).format('MM/DD/YYYY H:mm:ss');
                        this.plan.endDate =  moment(endDate).format('MM/DD/YYYY H:mm:ss');

                        this.$store.dispatch('ADD_PLAN', this.plan)
                                .then((res) => {
                                    console.log("ADD_PLAN res : ", res);
                                    if(res) this.showPopup('Success!', 'Plan is successfully created', 'success', ()=>this.$router.push('/admin/plan'))
                                    else this.showPopup('Error!', 'Unable to process.', 'error')
                                })
                                .catch(err => {
                                    this.showPopup('Error!', 'Plan name is already created.', 'error')
                                    console.log("ADD_Plan API error : ", err);
                                })

                    }
                })
            }
            console.log("this.plan : ", this.plan);
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    }

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Plans/CreatePlan.vue